"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGiftInvitationTemplates = void 0;

var _reactRedux = require("react-redux");

var _react = require("react");

var _giftInvitationTemplates = require("../store/entities/giftInvitationTemplates/giftInvitationTemplates.selectors");

var _giftInvitationTemplates2 = require("../store/entities/giftInvitationTemplates/giftInvitationTemplates.actions");

var useAll = function useAll() {
  return (0, _reactRedux.useSelector)(_giftInvitationTemplates.getGiftInvitationTemplatesAll);
};

var useGiftInvitationTemplates = function useGiftInvitationTemplates() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var isIdle = (0, _reactRedux.useSelector)(_giftInvitationTemplates.getIsGiftInvitationTemplatesIdle);
  var isFulfilled = (0, _reactRedux.useSelector)(_giftInvitationTemplates.getIsGiftInvitationTemplatesFulfilled);
  var isPending = (0, _reactRedux.useSelector)(_giftInvitationTemplates.getIsGiftInvitationTemplatesPending);
  var selectedId = (0, _reactRedux.useSelector)(_giftInvitationTemplates.getGiftInvitationTemplateId);
  var fetchData = (0, _react.useCallback)(function (giftInvitationTemplateId) {
    return dispatch((0, _giftInvitationTemplates2.fetchGiftInvitationTemplates)({
      giftInvitationTemplateId
    }));
  }, [dispatch]);
  var clearData = (0, _react.useCallback)(function () {
    return dispatch((0, _giftInvitationTemplates2.clearGiftInvitationTemplates)());
  }, [dispatch]);
  return (0, _react.useMemo)(function () {
    return {
      isIdle,
      isFulfilled,
      isPending,
      fetchData,
      selectedId,
      clearData,
      useAll
    };
  }, [isIdle, isFulfilled, isPending, fetchData, selectedId, clearData]);
};

exports.useGiftInvitationTemplates = useGiftInvitationTemplates;